<template>
  <div>
    <div class="mainContainer">
      <div class="myLinks">
          <div class="link" style="cursor:pointer" @click="checked(index)" :class="item.activated ? 'linkActived' : ''"  v-for="(item,index) in dataList" :key="index">{{item.link}}
            <div  :class="item.activated ? 'active' : ''"></div>
          </div>
        </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TabBar',
  props: ['items'],
  data() {
    return {
      dataList:[]
    }
  },
  mounted() {
    this.dataList = JSON.parse(JSON.stringify(this.items))
    console.log(this.dataList)
  },
  methods: {
    checked(i){
       this.dataList = this.dataList.map((item,index)=> {
         if (index == i) {
           item.activated = true
         }else {
           item.activated = false
         }
          return item
      })
      // console.log(this.dataList)
      this.$emit('func',i)
    }
  },
}
</script>

<style lang="less" scoped>

.mainContainer {
  background-color: #fff;
}
.myLinks {
  display: flex;
  flex-direction: row;
  .link {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 168px;
    height: 80px;
    text-align: center;
    color: #303133;
    font-size: 16px;
    div {
      margin-top: 10px;
      width: 80px;
      height: 4px;
    }
    .active {
      background-color: #002FA7;
    }
  }
  .linkActived {
      color: #002FA7;
    }
}
</style>